import { useWindowEvent } from "src/hooks/useWindowEvent"

export function useBackwardForwardCacheRestored(callback: () => void) {
  useWindowEvent("pageshow", (event) => {
    // Chrome bfcache https://web.dev/articles/bfcache restores the entire
    // memory snapshot of the page. The form is therefore still submitting after
    // going back using browser back. We detect this and reset the state.
    if (event.persisted) {
      callback()
    }
  })
}
